var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"app-button",attrs:{"disabled":_vm.disabled || _vm.loading}},[_vm._t("default"),(_vm.loading)?_c('div',{staticClass:"spinner-border",attrs:{"role":"status"}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }